import { VueJed } from '@didi/gettext'
import { getLanguage } from '@/utils/common/locale'

import enUS from './i18n/en-US.js' // 在执行 rgettext-extract 之前，该文件不存在
import zhCN from './i18n/zh-CN.js'
import esMX from './i18n/es-MX.js'
import esCO from './i18n/es-CO.js'
import ptBR from './i18n/pt-BR.js'
import es419 from './i18n/es-419.js'

const map = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'es-MX': esMX,
  'es-CO': esCO,
  'es-419': es419,
  'pt-BR': ptBR,
}
const language = getLanguage().long
export default new VueJed(map[language])
